// lỗi OCB bank trả về
export const dataErrorTPB = {
    ["2011"]: {text: "Giao dịch bị Timeout."},
    ["2012"]: {text: "Giao dịch thất bại."},
    ["2013"]: {text: "Dịch vụ Facepay hiện không khả dụng."},
    ["2014"]: {text: "Dịch vụ Facepay hiện không khả dụng."},
    ["2016"]: {text: "Không thể xác định khuôn mặt."},
    ["1101"]: {text: "Mã CIF hoặc Token không hợp lệ."},
    ["1103"]: {text: "Mã CIF hoặc Token không hợp lệ."},
    ["1104"]: {text: "Khuôn mặt chưa được đăng ký."},
    ["1106"]: {text: "Số điện thoại không đúng."},
    ["1107"]: {text: "Ảnh không trùng với ảnh đăng ký"},
    ["1108"]: {text: "Không nhận diện được khuôn mặt."},
    ["1109"]: {text: "Giao dịch không thể xác định."},
    ["10"]: {text: "Khuôn mặt chưa được đăng ký."},
    ["-99"]: {text: "Không nhận được lỗi từ ngân hàng"},
    ["-100"]: {text: "Giao dịch chưa hoàn tất"},
    ["40"]: {text: "Giao dịch có lỗi phát sinh từ TPBank"},
    ["21"]: {text: "Khuôn mặt không trùng khớp"},
    ["default"]: {text: "Giao dịch không thành công"},


}